import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
    DEFAULT_RECENTLY_ACTIVE,
    DEFAULT_RECENTLY_ACTIVE_DAYS,
    DEFAULT_RECENTLY_CLOSED,
    DEFAULT_RECENTLY_CLOSED_DAYS,
    DEFAULT_TEAM_FOCUSES,
    DEFAULT_TEAM_RECENTLY_ACTIVE_DAYS,
    DEFAULT_TEAM_RECENTLY_CLOSED_DAYS,
    FocusSelectionParams,
} from '../../../../../coaching-base/config';
import { CommitmentService } from '../../../../../coaching-commitment/services/commitment.service';
import { dedup } from '../../../../../coaching-tags/tags/tags.function';
import { Dependencies } from '../../../../../store';
import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../behaviour-selection-dialog.action';

import { Load, loadResult, LoadResult } from './load.action';

export const loadEpic = (
    action: ActionsObservable<PayloadAction<ActionType, Load>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, LoadResult>> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__BSD__LOAD),
        switchMap((act) => {
            const commitmentService =
                deps.injector?.get<CommitmentService>(CommitmentService);

            return of(null).pipe(
                commitmentService.retrieveCommitmentConfig(),
                switchMap((config) => {
                    return of(null).pipe(
                        commitmentService.listFocuses(() => {
                            const params: FocusSelectionParams =
                                config.focusSelectionParams ?? {};
                            return {
                                userId: act.payload.performerId ?? 0,
                                recentlyActive:
                                    params.recentlyActive != null
                                        ? params.recentlyActive
                                        : DEFAULT_RECENTLY_ACTIVE,
                                recentlyActiveDays:
                                    params.recentlyActiveDays != null
                                        ? params.recentlyActiveDays
                                        : DEFAULT_RECENTLY_ACTIVE_DAYS,
                                recentlyClosed:
                                    params.recentlyClosed != null
                                        ? params.recentlyClosed
                                        : DEFAULT_RECENTLY_CLOSED,
                                recentlyClosedDays:
                                    params.recentlyClosedDays != null
                                        ? params.recentlyClosedDays
                                        : DEFAULT_RECENTLY_CLOSED_DAYS,
                                teamFocuses:
                                    params.teamFocuses != null
                                        ? params.teamFocuses
                                        : DEFAULT_TEAM_FOCUSES,
                                teamRecentlyActiveDays:
                                    params.teamRecentlyActiveDays != null
                                        ? params.teamRecentlyActiveDays
                                        : DEFAULT_TEAM_RECENTLY_ACTIVE_DAYS,
                                teamRecentlyClosedDays:
                                    params.teamRecentlyClosedDays != null
                                        ? params.teamRecentlyClosedDays
                                        : DEFAULT_TEAM_RECENTLY_CLOSED_DAYS,
                            };
                        }),
                    );
                }),
                map((ret) => {
                    return dedup(
                        ret.userBehaviours ?? [],
                        (e) => e.behaviourId ?? '',
                    ).map((e) => ({
                        id: e.behaviourId ?? 0,
                        initials: e.behaviourName ?? '',
                        shortName: e.behaviourName ?? '',
                        name: e.behaviourName ?? '',
                    }));
                }),
                map((behaviours) =>
                    loadResult(
                        {
                            ...act.payload,
                            behaviours,
                            focuses: act.payload.focuses,
                        },
                        act.storePath,
                    ),
                ),
                catchError((err) => {
                    console.log(err);
                    return of(loadResult({ ...act.payload }, act.storePath));
                }),
            );
        }),
    );
